import { Group, Text } from '@mantine/core';
import { IconPhoneCall, IconVideo } from '@tabler/icons-react';
import { callMessageLabel, parseCallMessage } from '@domain/call/message';
import type { ChatMessage } from '@domain/chat/types';
export function CallMessageCard({ message, isMine }: { message: ChatMessage; isMine: boolean }) {
  const call = parseCallMessage(message.msgData); if (!call) return <Text size="sm">通话记录无效</Text>;
  const duration = call.durationMs ? `${Math.floor(call.durationMs / 60000)}:${String(Math.floor(call.durationMs / 1000) % 60).padStart(2, '0')}` : null;
  const Icon = call.media === 'video' ? IconVideo : IconPhoneCall;
  const detail = `${callMessageLabel(call)}${duration ? ` ${duration}` : ''}`;
  const attention = ['missed', 'failed', 'disconnected'].includes(call.outcome);
  const foreground = isMine ? 'white' : attention ? 'red.7' : 'var(--locs-text-muted)';
  return (
    <Group
      wrap="nowrap"
      gap={6}
      miw={34}
      data-testid={`call-message-${message.msgId}`}
      data-call-outcome={call.outcome}
      aria-label={detail}
    >
      <Icon
        size={18}
        stroke={1.9}
        color={isMine ? 'white' : attention ? 'var(--mantine-color-red-7)' : 'var(--locs-terracotta)'}
      />
      <Text size="sm" lh={1.3} fw={attention ? 600 : 500} c={foreground}>
        {detail}
      </Text>
    </Group>
  );
}
